<template>
  <div
    class="relative"
    ref="containerRef"
  >
    <div @click="toggle">
      <slot></slot>
    </div>

    <div
      v-if="isOpen"
      ref="contentRef"
      :style="floatingStyles"
      class="bg-gray-25 z-50 border border-gray-200 shadow-xl rounded-lg p-1"
      :class="contentClass"
      @click="handleContentClick"
    >
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { useFloating, autoUpdate, offset as dropdownOffset, flip, shift } from '@floating-ui/vue';

defineOptions({
  name: 'TheDropdown',
});

const props = defineProps({
  placement: {
    type: String,
    default: 'bottom-start',
  },
  closeOnClickOutside: {
    type: Boolean,
    default: true,
  },
  closeOnClickInside: {
    type: Boolean,
    default: true,
  },
  contentClass: {
    type: String,
    default: '',
  },
  offset: {
    type: Number,
    default: 4,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const isOpen = ref(false);
const containerRef = ref(null);
const contentRef = ref(null);

const { floatingStyles } = useFloating(containerRef, contentRef, {
  open: isOpen,
  placement: props.placement,
  whileElementsMounted: autoUpdate,
  middleware: [dropdownOffset(props.offset), flip(), shift()],
});

const toggle = () => {
  if (props.disabled) {
    return;
  }
  isOpen.value = !isOpen.value;
};

const close = () => {
  isOpen.value = false;
};

watch(
  () => props.disabled,
  (disabled) => {
    if (disabled) {
      close();
    }
  }
);

const handleClickOutside = (event) => {
  if (props.closeOnClickOutside && !containerRef.value.contains(event.target)) {
    isOpen.value = false;
  }
};

const handleContentClick = () => {
  if (props.closeOnClickInside) {
    isOpen.value = false;
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside);
});

defineExpose({
  close,
});
</script>
